import type { NextPage } from 'next';
import Error from 'next/error';

import { globalContentController, pageController } from '@controllers/index';
import { rowFactory } from '@factories/index';

import { renderComponents } from '@lib/utils';

import { logger } from '@lib/logger';

export const getServerSideProps = async () => {
  let page: any = {};
  let pages: any = [];
  let footerData: any = [];
  let registerInterestData: any = [];

  try {
    page = await pageController.getLegalPage();
    pages = await pageController.getPages();
    footerData = await globalContentController.getFooter();
    registerInterestData = await globalContentController.getRegisterInterestData();
  } catch (err) {
    logger.error(err);
  }

  const headerData = pageController.getHeaderData({ page: null, pages });
  const featureList = pageController.getFeatureList({ page });

  return {
    props: {
      headerData,
      footerData,
      registerInterestData,
      featureList: { list: featureList },
      layoutProps: { headerInverted: false, gradientBackground: true },
      data: {
        page,
      },
    },
  };
};

const LegalPage: NextPage = ({ headerData, data }: any) => {
  if (!headerData || !data?.page) {
    return <Error statusCode={404} />;
  }

  const linkLists =
    data?.page?.linkLists?.map(({ heading, listItem }: any) => ({
      heading,
      listItem: listItem?.map(({ link, label }: any) => ({
        label: label || '',
        link: `/legal/page/${link}`,
      })),
    })) || [];

  const attributes = {
    display: data?.page?.display,
    heading: data?.page?.heading || 'Legal',
    linkLists,
  };

  const LinkLists = rowFactory.createRow({
    type: 'linkLists',
    attributes,
  });

  return renderComponents({ components: [LinkLists] });
};

export default LegalPage;
